import React, { useRef } from 'react';

import { Bloc } from '../../../routes/project/components/step-drawer';
import { HistoryInput, HistoryInputRef } from '../../../components/history-input/history-input';

interface TextInputProps {
  value: string;
  label?: string | null;
  onChange: (value: string) => void;
}

export const InputDrawer: React.FC<TextInputProps> = ({ value, label, onChange }) => {
  const inputRef = useRef<HistoryInputRef>(null);

  const handleFocus = () => {
    inputRef.current?.focus();
  };

  return (
    <Bloc onClick={handleFocus}>
      <label>{label}</label>

      <HistoryInput ref={inputRef} value={value} onChange={onChange} />
    </Bloc>
  );
};
